import React, { Component } from "react"; 
import Heading from '../Heading.jsx';
import SinglePortfolio from './SinglePortfolio.jsx';
import Btn from '../Btn.jsx';

class PortfolioSec extends Component {
  render() {
    return (
     <div>
       <div id="Portfolio" style={{background:"#111a28"}}>
           <div className="container">
           <div className="row">
                <div className="col-12 text-center">
                    <Heading heading={this.props.heading}/>
                </div>
            </div>
            <div className="row mt-5">
            <SinglePortfolio projectName='Professionals Brunssum 1' projectCode='https://github.com/faysalchowdhury99/professionals-brunssum-1' projectLink='https://faysalchowdhury99.github.io/professionals-brunssum-1/' cat='XD to HTML'>
            <p>HTML</p>
            <p>CSS</p>
            <p>JAVASCRIPT</p>
            <p>JQUERY</p>
            <p>BOOTSTRAP</p>
            </SinglePortfolio>
            
            <SinglePortfolio projectName='Professionals Brunssum 2' projectCode='https://github.com/faysalchowdhury99/professionals-brunssum-2' projectLink='https://faysalchowdhury99.github.io/professionals-brunssum-2/' cat='XD to HTML'>
            <p>HTML</p>
            <p>CSS</p>
            <p>JAVASCRIPT</p>
            <p>JQUERY</p>
            <p>BOOTSTRAP</p>
            </SinglePortfolio>

            <SinglePortfolio projectName='Gaming Time' projectCode='https://github.com/faysalchowdhury99/gaming-time' projectLink='https://faysalchowdhury99.github.io/gaming-time/' cat='XD to HTML'>
            <p>HTML</p>
            <p>CSS</p>
            <p>JQUERY</p>
            <p>BOOTSTRAP</p>
            </SinglePortfolio>

            <SinglePortfolio projectName='Studyly' projectCode='https://github.com/faysalchowdhury99/studyly' projectLink='https://faysalchowdhury99.github.io/studyly/' cat='XD to HTML'>
            <p>HTML</p>
            <p>CSS</p>
            <p>JAVASCRIPT</p>
            <p>JQUERY</p>
            <p>BOOTSTRAP</p>
            </SinglePortfolio>

            <SinglePortfolio projectName='Organic' projectCode='https://github.com/faysalchowdhury99/organic' projectLink='https://faysalchowdhury99.github.io/organic/' cat='URL to HTML'>
            <p>HTML</p>
            <p>CSS</p>
            <p>JAVASCRIPT</p>
            <p>JQUERY</p>
            <p>BOOTSTRAP</p>
            </SinglePortfolio>

            <SinglePortfolio projectName='Brac' projectCode='https://github.com/faysalchowdhury99/brac' projectLink='https://faysalchowdhury99.github.io/brac/' cat='XD to HTML'>
            <p>HTML</p>
            <p>CSS</p>
            <p>JAVASCRIPT</p>
            <p>JQUERY</p>
            <p>BOOTSTRAP</p>
            </SinglePortfolio>

            <div className="text-center mt-5">
            <Btn href='https://github.com/faysalchowdhury99?tab=repositories' btn='আরও দেখুন' />
            </div>
            
            </div>
           </div>
           <div className="space"></div>
       </div>
     </div>
    );
  }
}

export default PortfolioSec;